import { groupBy } from "lodash";
import { Item__Atividades, ItemPropriedades } from "../../../../../../../services/atividades/GET";

export type filtarAtividadesSaida = {
    cod_talhao: number,
    is_subarea?: boolean,
    nome_talhao: string,
    nome_propriedade: string,
    atvs_planejadas: number,
    atvs_executadas: number,
    atvs_concluidas: number,
    lista_atividades: Item__Atividades[]
}
export function filtarAtividades(cod_filtrar_atividade: number, data_atividades: Item__Atividades[], data_propriedades: ItemPropriedades[]): filtarAtividadesSaida[] {

    //@ts-ignore
    const lista_talhoes = (data_propriedades ?? []).map(item => item.talhao).flat();

    function obterNomeTalhao(cod_talhao: number) {
        let find_talhao = (lista_talhoes ?? [])?.find(item => item.cod === cod_talhao)?.nome ?? null
        return find_talhao ?? '???'
    };

    let atividades_da_propriedade__01 = (data_atividades ?? []).filter(i => i.cod_propriedade === cod_filtrar_atividade);

    let agrupar_por_talhao__02 = groupBy(atividades_da_propriedade__01, 'cod_talhao');

    function obterQtdExecutada(cod_talhao: number) {
        //@ts-ignore
        let executadas = (atividades_da_propriedade__01 ?? []).filter(i => i.cod_tipo === 2 && i.cod_talhao == cod_talhao).map(i => i.andamentos).flat();
        return executadas?.length ?? 0;
    }

    let estrutura__03 = (Object.entries(agrupar_por_talhao__02) ?? []).map(([cod_talhao, lista_atividades]) => {
        return {
            cod_talhao: Number(cod_talhao),
            is_subarea: lista_talhoes.some(i => i.cod_talhao === Number(cod_talhao)),
            nome_talhao: obterNomeTalhao(Number(cod_talhao)),
            nome_propriedade: lista_atividades?.[0]?.propriedade_nome,
            atvs_planejadas: ((lista_atividades ?? [])?.filter(i => i.cod_tipo === 1))?.length ?? 0,
            atvs_executadas: obterQtdExecutada(Number(cod_talhao)) ?? 0,
            atvs_concluidas: (lista_atividades ?? []).filter(i => i.concluido)?.length ?? 0,
            lista_atividades: lista_atividades
        }
    })

    return estrutura__03 ?? [];
};

export function filtarAtividadesPorTralhao(cod_filtrar_atividade: number, data_atividades: Item__Atividades[], data_propriedades: ItemPropriedades[]): filtarAtividadesSaida[] {

    //@ts-ignore
    const lista_talhoes = (data_propriedades ?? []).map(item => item.talhao).flat();

    function obterNomeTalhao(cod_talhao: number) {
        let find_talhao = (lista_talhoes ?? [])?.find(item => item.cod === cod_talhao)?.nome ?? null
        return find_talhao ?? '???'
    };

    let atividades_da_propriedade__01 = (data_atividades ?? []).filter(i => i.cod_talhao === cod_filtrar_atividade);

    let agrupar_por_talhao__02 = groupBy(atividades_da_propriedade__01, 'cod_talhao');

    function obterQtdExecutada(cod_talhao: number) {
        //@ts-ignore
        let executadas = (atividades_da_propriedade__01 ?? []).filter(i => i.cod_tipo === 2 && i.cod_talhao == cod_talhao).map(i => i.andamentos).flat();
        return executadas?.length ?? 0;
    }

    let estrutura__03 = (Object.entries(agrupar_por_talhao__02) ?? []).map(([cod_talhao, lista_atividades]) => {
        return {
            cod_talhao: Number(cod_talhao),
            is_subarea: lista_talhoes.some(i => i.cod_talhao === Number(cod_talhao)),
            nome_talhao: obterNomeTalhao(Number(cod_talhao)),
            nome_propriedade: lista_atividades?.[0]?.propriedade_nome,
            atvs_planejadas: ((lista_atividades ?? [])?.filter(i => i.cod_tipo === 1))?.length ?? 0,
            atvs_executadas: obterQtdExecutada(Number(cod_talhao)) ?? 0,
            atvs_concluidas: (lista_atividades ?? []).filter(i => i.concluido)?.length ?? 0,
            lista_atividades: lista_atividades
        }
    });

    return estrutura__03 ?? [];
};


export type ItemListaAtividades = {
    /**Nome da atividade (`descricao`) usado como identificador (consolidado) */
    nome: string,
    /**Operação a qual a atividade pertence (ex: Plantio, Colheita) */
    tipo_operacao: string,
    /**Quantidade de atividades planejadas que possuem esse nome */
    quantidade: number,
    /**Dias de referência da atividade (negativo = antes do dia zero) */
    dias: number | null,
    /**Data de início mais antiga entre as atividades consolidadas (usada na ordenação) */
    data_inicio: string | null,
    /**Cor do texto da tag, seguindo o padrão de cores das atividades */
    cor_texto: string,
    /**Cor de fundo da tag, seguindo o padrão de cores das atividades */
    cor_fundo: string
}

/**Padrão de cores das atividades conforme o `dias`:
 * - `azul`: antes do dia zero (dias negativo)
 * - `verde escuro`: dia zero
 * - `verde`: depois do dia zero (dias positivo) */
export function obterCoresPorDias(dias: number | null): { cor_texto: string, cor_fundo: string } {

    //ANTES DO DIA ZERO
    if (Number(dias) < 0) {
        return { cor_texto: '#0958d9', cor_fundo: '#e0edf8' };
    }
    //DIA ZERO
    if (Number(dias) === 0) {
        return { cor_texto: '#237804', cor_fundo: '#d9f7be' };
    }
    //DEPOIS DO DIA ZERO
    return { cor_texto: '#52c41a', cor_fundo: '#effedf' };
};
/**Consolida as atividades planejadas (`cod_tipo === 1`) de todos os talhões por nome
 * da atividade (sem repetir), para alimentar o select do modo `Por atividade` */
export function listarAtividadesConsolidadas(data_atividades: Item__Atividades[]): ItemListaAtividades[] {

    //APENAS ATIVIDADES PLANEJADAS
    const atividades_com_nome = (data_atividades ?? [])
        .filter(item => item.cod_tipo === 1)
        .map(item => ({ item: item, nome: String(item.descricao ?? '').trim() }))
        .filter(({ nome }) => !!nome);

    //AGRUPA IGNORANDO CAIXA E ESPAÇOS PARA NÃO REPETIR O MESMO NOME ESCRITO DE FORMAS DIFERENTES
    const agrupado_por_nome = groupBy(atividades_com_nome, ({ nome }) => nome.toLowerCase());

    return (Object.entries(agrupado_por_nome) ?? [])
        .map(([, lista]) => {

            const referencia = (lista ?? []).find(({ item }) => item.dias != null);
            const dias = referencia?.item?.dias != null ? Number(referencia.item.dias) : null;

            //DATA MAIS ANTIGA ENTRE AS ATIVIDADES DO GRUPO
            const data_inicio = (lista ?? [])
                .map(({ item }) => item.data_inicio)
                .filter(data => !!data)
                .sort()?.[0] ?? null;

            return {
                nome: lista?.[0]?.nome,
                tipo_operacao: (lista ?? []).find(({ item }) => !!item.tipo_operacao)?.item?.tipo_operacao ?? '',
                quantidade: (lista ?? []).length,
                dias: dias,
                data_inicio: data_inicio,
                ...obterCoresPorDias(dias)
            }
        })
        //ORDENA PELA DATA DE INÍCIO. SEM DATA VAI PARA O FIM DA LISTA
        .sort((a, b) => {
            if (!a.data_inicio && !b.data_inicio) return a.nome.localeCompare(b.nome);
            if (!a.data_inicio) return 1;
            if (!b.data_inicio) return -1;
            return a.data_inicio.localeCompare(b.data_inicio);
        });
};

export type ItemProgressoPorAtividade = {
    key: string,
    /**Nome do talhão */
    nome: string,
    cod_talhao: number,
    cod_propriedade: number,
    nome_propriedade: string,
    /**Progresso da atividade no talhão (`porcentagem_executada`) */
    porcentagem: number,
    area_total: number,
    /**`false` quando o talhão não possui a atividade planejada */
    is_planejada: boolean
}
export type ProgressoPorAtividade = {
    talhoes: ItemProgressoPorAtividade[],
    /**Quantidade de talhões que possuem a atividade planejada */
    qtd_talhoes: number,
    /**Soma das áreas planejadas dos talhões */
    area_planejada: number,
    /**Progresso geral da atividade, ponderado pela área de cada talhão */
    progresso_geral: number
}

/**Monta o progresso da atividade selecionada em cada talhão, usando o `porcentagem_executada`.
 * Alimenta o gráfico do modo `Por atividade` */
export function progressoPorAtividade(
    nome_atividade: string,
    data_atividades: Item__Atividades[],
    data_propriedades: ItemPropriedades[],
    cod_propriedade?: number
): ProgressoPorAtividade {

    const vazio: ProgressoPorAtividade = { talhoes: [], qtd_talhoes: 0, area_planejada: 0, progresso_geral: 0 };

    if (!nome_atividade) return vazio;

    //@ts-ignore
    const lista_talhoes = (data_propriedades ?? []).map(item => item.talhao).flat();

    function obterNomeTalhao(cod_talhao: number) {
        return (lista_talhoes ?? []).find(item => item?.cod === cod_talhao)?.nome ?? '???';
    }
    function obterNomePropriedade(cod: number) {
        return (data_propriedades ?? []).find(item => item.cod === cod)?.nome ?? '';
    }

    const chave_atividade = nome_atividade.trim().toLowerCase();

    //APENAS AS PLANEJADAS DA ATIVIDADE SELECIONADA
    let atvs_da_atividade = (data_atividades ?? []).filter(item =>
        item.cod_tipo === 1 && String(item.descricao ?? '').trim().toLowerCase() === chave_atividade
    );

    //RESPEITA O FILTRO DE PROPRIEDADE DA TELA
    if (Number(cod_propriedade) > 0) {
        atvs_da_atividade = atvs_da_atividade.filter(item => item.cod_propriedade === cod_propriedade);
    }

    //UM TALHÃO PODE TER A MESMA ATIVIDADE MAIS DE UMA VEZ, ENTÃO AGRUPA POR TALHÃO
    const agrupado_por_talhao = groupBy(atvs_da_atividade, 'cod_talhao');

    const talhoes = (Object.entries(agrupado_por_talhao) ?? []).map(([cod_talhao, lista], index) => {

        const area_total = (lista ?? []).reduce((acc, i) => acc + Number(i.area ?? 0), 0);

        /**Com mais de uma ocorrência no talhão, o progresso é a média ponderada pela área.
         * Sem área informada, cai na média simples para não zerar o progresso */
        function obterPorcentagem(): number {
            const soma_ponderada = (lista ?? []).reduce((acc, i) =>
                acc + (Number(i.porcentagem_executada ?? 0) * Number(i.area ?? 0)), 0);

            if (area_total > 0) return soma_ponderada / area_total;

            const soma_simples = (lista ?? []).reduce((acc, i) => acc + Number(i.porcentagem_executada ?? 0), 0);
            return (lista ?? []).length > 0 ? soma_simples / (lista ?? []).length : 0;
        }

        return {
            key: `${cod_talhao}_${index}_atividade`,
            nome: obterNomeTalhao(Number(cod_talhao)),
            cod_talhao: Number(cod_talhao),
            cod_propriedade: lista?.[0]?.cod_propriedade,
            nome_propriedade: lista?.[0]?.propriedade_nome ?? obterNomePropriedade(lista?.[0]?.cod_propriedade),
            porcentagem: obterPorcentagem(),
            area_total: area_total,
            is_planejada: true
        }
    });

    //ORDENA DO MAIOR PROGRESSO PARA O MENOR
    const talhoes_ordenados = talhoes.sort((a, b) => b.porcentagem - a.porcentagem);

    const area_planejada = talhoes_ordenados.reduce((acc, i) => acc + i.area_total, 0);

    //PROGRESSO GERAL PONDERADO PELA ÁREA DE CADA TALHÃO
    function obterProgressoGeral(): number {
        if (talhoes_ordenados.length === 0) return 0;

        if (area_planejada > 0) {
            const soma = talhoes_ordenados.reduce((acc, i) => acc + (i.porcentagem * i.area_total), 0);
            return soma / area_planejada;
        }

        const soma = talhoes_ordenados.reduce((acc, i) => acc + i.porcentagem, 0);
        return soma / talhoes_ordenados.length;
    }

    return {
        talhoes: talhoes_ordenados,
        qtd_talhoes: talhoes_ordenados.length,
        area_planejada: area_planejada,
        progresso_geral: obterProgressoGeral()
    }
};

export function obterDetalhesAtvspropriedades(cod_filtrar_atividade: number, data_atividades: Item__Atividades[]) {

    let atvs_da_propriedade = (data_atividades ?? []).filter(i => i.cod_propriedade === cod_filtrar_atividade);
    //@ts-ignore
    let executadas = (atvs_da_propriedade ?? []).filter(i => i.cod_tipo === 2).map(i => i.andamentos).flat();
    return {
        area_total: atvs_da_propriedade?.reduce((acc, i) => acc + Number(i.area), 0) ?? 0,
        area_executada: atvs_da_propriedade?.reduce((acc, i) => acc + Number(i.area_executada), 0) ?? 0,
        qtd_planejadas: (atvs_da_propriedade ?? []).filter(i => i.cod_tipo === 1).length ?? 0,
        qtd_executadas: executadas?.length,
        qtd_concluidas: atvs_da_propriedade?.filter(i => i.concluido).length ?? 0
    }
}

export function obterDetalhesAtvsTalhoes(cod_filtrar_atividade: number, data_atividades: Item__Atividades[]) {

    let atvs_do_talhao = (data_atividades ?? []).filter(i => i.cod_talhao === cod_filtrar_atividade);
    //@ts-ignore
    let executadas = (atvs_do_talhao ?? []).filter(i => i.cod_tipo === 2).map(i => i.andamentos).flat();
    return {
        area_total: atvs_do_talhao?.reduce((acc, i) => acc + Number(i.area), 0) ?? 0,
        area_executada: atvs_do_talhao?.reduce((acc, i) => acc + Number(i.area_executada), 0) ?? 0,
        qtd_planejadas: (atvs_do_talhao ?? []).filter(i => i.cod_tipo === 1).length ?? 0,
        qtd_executadas: executadas?.length,
        qtd_concluidas: atvs_do_talhao?.filter(i => i.concluido).length ?? 0
    }
}